import {Stack, styled} from '@mui/material'

export const FullWidthStack = styled(Stack)`
  width: 100%;
`
